export default "https://cdn-static.gokick.com/assets/5afcce0631de89212d84c9203934006157ee1462/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";